import type { ReactNode } from 'react';

import { cn } from '@/ui/utils/classnames';

export interface ListButtonProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  onClick?: () => void;
}

function ListButton({
  children,
  className,
  dataTestId,
  disabled,
  onClick,
}: ListButtonProps) {
  return (
    <button
      className={cn(
        'ml-[-16px] flex w-[calc(100%+32px)] rounded-xl px-4 transition-colors',
        '[li:has(>&,>div>button]:transition-colors enabled:hover:-my-px enabled:hover:bg-black/6 enabled:hover:py-px theme-dark:enabled:hover:bg-white/6 [&:hover:enabled+ul]:!border-transparent [li:has(>&:hover:enabled,>div>button:hover):not(:has(ul))+li]:!border-transparent [li:has(>&:hover:enabled,>div>button:hover:enabled)]:!border-transparent [ul:has(>li:first-child_&)]:transition-colors [ul:has(>li:first-child_&:hover:enabled)]:!border-transparent',
        className,
      )}
      type="button"
      data-testid={dataTestId}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default ListButton;
